export default "__VITE_ASSET__C406QJ78__"